import { get, post, put } from '../../index.js'
import base from '../../base.js'


export const getFollowUpList = (params) => get(base.followUpList, params)
export const postFollowUp = (params) => post(base.followUp, params)
export const putWorkReport = (params) => put(base.workReport, params)
export const getFollowUp = (id) => get(`${base.followUp}/${id}`)
